import { render, staticRenderFns } from "./DeviceCardInternal.vue?vue&type=template&id=134ffc58&"
import script from "./DeviceCardInternal.vue?vue&type=script&lang=js&"
export * from "./DeviceCardInternal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports